import { badge } from '../components/ui/uiTheme';

/** @typedef {'default'|'success'|'warning'|'error'|'sky'|'violet'|'slate'|'info'|'purple'|'teal'} StatusPillVariant */

const VARIANT_CLASS = {
  default: badge.default,
  success: badge.success,
  warning: badge.warning,
  error: badge.error,
  sky: badge.sky,
  violet: badge.violet,
  slate: badge.slate,
  info: badge.info,
  purple: badge.purple,
  teal: badge.teal,
};

/**
 * @param {StatusPillVariant} variant
 * @returns {string}
 */
export function getStatusPillClass(variant) {
  return VARIANT_CLASS[variant] || VARIANT_CLASS.default;
}

/** Performance review cycle status pill. */
export function reviewCycleStatusBadgeClass(status) {
  if (status === 'active')
    return 'bg-vivid-green-cyan/20 text-vivid-green-cyan text-xs font-medium rounded-full px-2.5 py-0.5';
  if (status === 'scheduled') return getStatusPillClass('sky');
  if (status === 'closed') return getStatusPillClass('default');
  if (status === 'canceled') return getStatusPillClass('warning');
  return getStatusPillClass('default');
}

/** Survey hub status pill. */
export function surveyStatusBadgeClass(status) {
  const raw = (status || '').toLowerCase();
  if (raw === 'active') return getStatusPillClass('success');
  if (raw === 'draft')
    return 'bg-dark-elevated text-slate-200 text-xs font-medium rounded-full px-2.5 py-0.5';
  if (raw === 'scheduled') return getStatusPillClass('info');
  if (raw === 'closed') return getStatusPillClass('slate');
  if (raw === 'cancelled') return getStatusPillClass('error');
  return getStatusPillClass('default');
}

/** Code index job status pill. */
export function codeIndexStatusBadgeClass(status) {
  switch (status) {
    case 'success':
      return getStatusPillClass('success');
    case 'running':
      return getStatusPillClass('sky');
    case 'failed':
      return getStatusPillClass('error');
    case 'pending':
    default:
      return 'bg-dark-elevated text-slate-200 text-xs font-medium rounded-full px-2.5 py-0.5';
  }
}

/** Portfolio briefing category pill. */
export function briefingCategoryBadgeClass(category) {
  switch (category) {
    case 'missing':
      return getStatusPillClass('sky');
    case 'ready':
      return getStatusPillClass('success');
    case 'stale':
      return getStatusPillClass('warning');
    case 'generating':
      return getStatusPillClass('violet');
    case 'failed':
      return getStatusPillClass('error');
    case 'not_ready':
    default:
      return getStatusPillClass('default');
  }
}
